export default __webpack_public_path__ + "static/portfolio-basic-grid-312a5d3e572e431aa56af77a252afb8a.jpg";